const getClientTimeZone = (defaultTimeZone = "Etc/UTC") => {
  return (
    Intl?.DateTimeFormat?.()?.resolvedOptions?.()?.timeZone ?? defaultTimeZone
  );
};

export default getClientTimeZone;
